import { ELSStepperItem } from '@els/els-component-shared-ts-react';

export const SHERPATH_LESSON_EDITOR_PAGE_TITLE = 'Sherpath Lesson Assignment';

export const SHERPATH_LESSON_EDITOR_COMING_SOON_LABEL = 'Coming soon';

export enum SherpathLessonScreen {
  DETAILS = 'DETAILS',
  EDIT_CONTENT = 'EDIT_CONTENT',
}

export enum SherpathLessonStep {
  STEP1 = 'STEP1',
}

export const SherpathLessonDefaultSteps: ELSStepperItem[] = [
  {
    heading: 'Assignment',
    id: SherpathLessonStep.STEP1,
    isActive: false,
    isClickable: false,
    isComplete: false,
    isReady: false,
    showActionButtons: true,
    subtitle: 'Assign Lesson',
    title: 'Step 1',
  }
];
